<script>
// import axios from "axios";

import Layout from "../../../layouts/main";
// import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { required, minValue } from "vuelidate/lib/validators";
// import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
// import Loader from "@/components/widgets/loader";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Vue from "vue";
// import Vuetable from "vuetable-2";
// import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import { FulfillingBouncingCircleSpinner } from "epic-spinners";
import { helpers } from "../../../../helpers/helpers-validate";
import MaskedInput from "vue-text-mask";
import Switches from "vue-switches";
import DatePicker from "vue2-datepicker";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";
Vue.component("v-select", vSelect);
// register the plugin on vue
import Toasted from "vue-toasted";

Vue.use(Toasted);
// Lets Register a Global Error Notification Toast.
let nit = (value) => helpers.nitIsValid(value);
let correo = (value) => helpers.correo(value);
/**
 * new orden component
 */
export default {
  page: {
    title: "Nueva venta al crédito",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    DatePicker,
    Layout,
    // PageHeader,
    // DatePicker,
    Switches,
    // Vuetable,
    // VuetablePagination,
    // Loader,
    "fulfilling-bouncing-circle-spinner": FulfillingBouncingCircleSpinner,
    "masked-input": MaskedInput,
  },
  data() {
    return {
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      // variables metodos
      bandera: false,
      cantidad_efectivo: "",
      transferencia: [
        {
          cantidad_transferencia: "",
          transaccion_transferencia: "",
          button: true,
        },
      ],
      deposito: [
        {
          cantidad_deposito: "",
          transaccion_deposito: "",
          button: true,
        },
      ],
      cheque: [
        {
          cantidad_cheque: "",
          transaccion_cheque: "",
          button: true,
        },
      ],
      tarjeta: [
        {
          cantidad_tarjeta: "",
          transaccion_tarjeta: "",
          button: true,
        },
      ],
      checkMoney: {
        efectivo: false,
        transferencia: false,
        deposito: false,
        cheque: false,
        tarjeta: false,
      },
      checkSelect: {
        efectivo: false,
        transferencia: false,
        deposito: false,
        cheque: false,
        tarjeta: false,
      },
      montoFinal: {
        cantidad: 0,
        metodo: "",
        transaccion: "",
      },
      montos: {
        monto_efectivo: "",
        monto_transferencia: [],
        monto_deposito: [],
        monto_cheque: [],
        monto_tarjeta: [],
      },
      // variable credito
      formCredito: {
        fechaInicio: new Date(),
        intervalo: 8,
        collapse1: false,
        pagos: [],
        precioNuevo: 0,
        adelanto: "0",
        cantidadPagos: 0,
      },
      // variables nuevas
      toggleNit: false,
      porcentaje: "",
      indexPorcentaje: "",
      precioOriginal: "",
      precioDescuento: "",
      arrayProductos: [],
      producto: "",
      arrayServicios: [],
      servicio: "",
      busquedaLabel: { nombre: "Código", value: "codigo" },
      busquedaLabel2: { nombre: "Nombre", value: "nombre" },
      busquedaTipos: [
        { nombre: "Código", value: "codigo" },
        { nombre: "Nombre", value: "producto" },
      ],
      busquedaTipos2: [{ nombre: "Nombre", value: "nombre" }],
      fieldsProductos: [
        { key: "action", label: "Acciones" },
        { key: "producto", label: "Producto" },
        { key: "codigo", label: "Código" },
        { key: "existencia", label: "Existencia" },
        { key: "departamento", label: "Departamento" },
        { key: "estante", label: "Estante" },
        { key: "precio_venta", label: "Precio venta" },
      ],
      fieldsServicios: [
        { key: "action", label: "Acciones" },
        { key: "nombre_servicio", label: "Servicio" },
        { key: "descripcion_servicio", label: "Descripción" },
      ],
      fechaVec: "",
      switchCliente: true,
      formCliente: {
        nombre: "",
        apellido: "",
        nit: "C/F",
        opciones: ["MASCULINO", "FEMENINO"],
        direccion: "",
        telefono: "",
        telefono_proveedor: "",
        correo: "",
        cui: "",
        sexo: "",
        compania: "",
        direc: "",
        state: true,
        id: 0,
      },
      // variables para detalle
      ubicacionModel: 0,
      arrayEstante: [],
      estanteModel: 0,
      formget: {
        descripcion: "",
        pasillo: "",
        seccion: "",
        estante: "",
        departamentoId: "",
        id: 0,
      },
      activa_proveedor: false,
      cabezera: [
        { key: "Opciones", label: "Opciones" },
        { key: "producto", label: "Producto" },
        { key: "cantidad", label: "Cantidad" },
        { key: "precio_venta", label: "Precio Venta" },
        { key: "porcentaje", label: "Porcentaje descuento" },
        { key: "subtotal", label: "Subtotal", thClass: "cell1" },
      ],
      cabezera2: [
        { key: "Opciones", label: "Opciones" },
        { key: "nombre_servicio", label: "Servicio" },
        { key: "cantidad", label: "Cantidad" },
        { key: "precio_venta", label: "Precio Venta" },
        { key: "subtotal", label: "Subtotal" },
      ],
      arrayCliente: [],
      arrayDepa: [],
      arrayClientes: [],
      apiUrl: process.env.VUE_APP_URL,
      apiBase: process.env.VUE_APP_URL + "creditos_venta/get",
      apiBase2: process.env.VUE_APP_URL + "creditos_venta/get",
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
        pagination: {
          infoClass: "pull-left",
          wrapperClass: "vuetable-pagination pull-right",
          activeClass: "btn-primary",
          disabledClass: "disabled",
          pageClass: "btn btn-border",
          linkClass: "btn btn-border",
          icons: {
            first: "",
            prev: "",
            next: "",
            last: "",
          },
        },
      },
      formPro: {
        fecha_compra: new Date(),
        tiendaid: "",
        observaciones: "",
        tienda: "",
        proveedor: "",
        total: "",
        total_servicios: "",
        total_productos: "",
        state: true,
        id: 0,
      },
      data: [
        {
          nombre: "",
          cantidad: "",
          precio_compra: "",
          porcentaje_venta: "",
          precio_venta: "",
          subtotal: "",
          ubicacion: "",
          sub_presentacion: "",
          button: true,
        },
      ],
      title: "NUEVA VENTA",
      items: [
        {
          text: "Ventas",
          href: "/",
        },
        {
          text: "Nueva venta",
          active: true,
        },
      ],
      searchType: [
        { nombre: "Producto", value: "producto" },
        { nombre: "Codigo", value: "codigo" },
      ],
      searchType2: [{ nombre: "Nombre", value: "nombre" }],
      options: {
        theme: "outline",
        position: "top-right",
        duration: 5000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      loadingtable: false,
      sortBy: "nombre_producto",
      sortDesc: false,
      searchLabel: { nombre: "Producto", value: "producto" },
      filterLabel: { nombre: "Codigo", value: "codigo" },
      searchLabel2: { nombre: "Nombre", value: "nombre" },
      filterLabel2: { nombre: "Nombre", value: "nombre" },
      showModalL: false, //Loading
      showModalNP: false, //Nuevo Proveedor
      showModalN: false, //Nuevo registro
      showModalD: false, //Desactivar
      showModalA: false, //Activar
      pageOptions: [4, 10, 15, 20],
      search: "",
      search2: "",
      page: 1,
      perPage: 20,
      from: 0,
      to: 0,
      to2: 0,
      total: 0,
      total2: 0,
      lastPage: 0,
      lastPage2: 0,
      arrayDetalle: [],
      arrayDetalleServicio: [],
      idDepartamento: 0,
      traslado_masivo: false,
      arrayDet: [],
      mask_porcentaje: createNumberMask({
        prefix: "",
        suffix: " %",
        includeThousandsSeparator: true,
        thousandsSeparatorSymbol: ",",
        allowDecimal: true,
        decimalSymbol: ".",
        decimalLimit: 2, // how many digits allowed after the decimal
        integerLimit: 10, // limit length of integer numbers
        allowNegative: false,
        allowLeadingZeroes: false,
      }),
      mask_quetzal: createNumberMask({
        prefix: "Q ",
        suffix: "",
        includeThousandsSeparator: true,
        thousandsSeparatorSymbol: ",",
        allowDecimal: true,
        decimalSymbol: ".",
        decimalLimit: 2, // how many digits allowed after the decimal
        integerLimit: 10, // limit length of integer numbers
        allowNegative: false,
        allowLeadingZeroes: false,
      }),
    };
  },
  validations: {
    formCliente: {
      nombre: { required },
      apellido: { required },
      nit: { nit, required },
      direccion: { required },
      telefono: { required },
      correo: { correo, required },
      cui: { required },
      sexo: { required },
      compania: { required },
      direc: { required },
      telefono_proveedor: { required },
    },
    formPro: {
      fecha_compra: { required },
      tienda: { required },
      proveedor: { required },
      total: { required },
    },
    arrayDetalle: {
      $each: {
        subtotal: {
          required,
          minValue: minValue(1),
        },
        // precio_compra: {
        //   required,
        //   minValue: minValue(1),
        // },
        // precio_venta: {
        //   required,
        //   minValue: minValue(1),
        // },
        // ubicacion: {
        //   required,
        // },
      },
    },
    arrayDetalleServicio: {
      $each: {
        subtotal: {
          required,
          minValue: minValue(1),
        },
        // precio_venta: {
        //   required,
        //   minValue: minValue(1),
        // },
      },
    },
    data: { required },
    cantidad_efectivo: {
      required,
      // minValue: minValue(1),
    },
    transferencia: {
      required,
      $each: {
        cantidad_transferencia: {
          required,
          // minValue: minValue(1),
        },
        transaccion_transferencia: {
          required,
        },
      },
    },
    deposito: {
      required,
      $each: {
        cantidad_deposito: {
          required,
          // minValue: minValue(1),
        },
        transaccion_deposito: {
          required,
        },
      },
    },
    cheque: {
      required,
      $each: {
        cantidad_cheque: {
          required,
          // minValue: minValue(1),
        },
        transaccion_cheque: {
          required,
        },
      },
    },
    tarjeta: {
      required,
      $each: {
        cantidad_tarjeta: {
          required,
          // minValue: minValue(1),
        },
        transaccion_tarjeta: {
          required,
        },
      },
    },
    montoFinal: {
      cantidad: {
        minValue: minValue(1),
      },
    },
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
    this.getClientes();
    this.gettienda();
    // this.getProductos();
    // this.getServicios();
    this.getFechaVec();
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    calcularTotal: function () {
      let sum1 = 0.0;
      let sum2 = 0.0;
      let resultado = 0.0;
      if (this.arrayDetalle.length > 0) {
        for (let i = 0; i < this.arrayDetalle.length; i++) {
          if (
            this.arrayDetalle[i].subtotal == "" ||
            this.arrayDetalle[i].subtotal == null
          ) {
            sum1 = 0;
          } else {
            sum1 = parseFloat(sum1) + parseFloat(this.arrayDetalle[i].subtotal);
          }
        }
      }
      if (this.arrayDetalleServicio.length > 0) {
        for (let i = 0; i < this.arrayDetalleServicio.length; i++) {
          if (
            this.arrayDetalleServicio[i].subtotal == "" ||
            this.arrayDetalleServicio[i].subtotal == null
          ) {
            sum2 = 0;
          } else {
            sum2 =
              parseFloat(sum2) +
              parseFloat(this.arrayDetalleServicio[i].subtotal);
          }
        }
      }
      resultado = sum1 + sum2;
      return resultado.toFixed(2);
    },
    calcularProductos: function () {
      let sum1 = 0.0;
      if (this.arrayDetalle.length > 0) {
        for (let i = 0; i < this.arrayDetalle.length; i++) {
          if (
            this.arrayDetalle[i].subtotal == "" ||
            this.arrayDetalle[i].subtotal == null
          ) {
            sum1 = 0;
          } else {
            sum1 = parseFloat(sum1) + parseFloat(this.arrayDetalle[i].subtotal);
          }
        }
      }
      return sum1.toFixed(2);
    },
    calcularServicios: function () {
      let sum2 = 0;
      if (this.arrayDetalleServicio.length > 0) {
        for (let i = 0; i < this.arrayDetalleServicio.length; i++) {
          if (
            this.arrayDetalleServicio[i].subtotal == "" ||
            this.arrayDetalleServicio[i].subtotal == null
          ) {
            sum2 = 0;
          } else {
            sum2 =
              parseFloat(sum2) +
              parseFloat(this.arrayDetalleServicio[i].subtotal);
          }
        }
      }
      return sum2.toFixed(2);
    },
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    asignarCredito() {},
    asignarAdelanto() {
      if (
        parseFloat(this.converMaskToNumberxd(this.formCredito.adelanto)) > 0
      ) {
        // console.log("a");
        this.formCredito.collapse1 = true;
        this.formCredito.precioNuevo =
          this.formPro.total -
          parseFloat(this.converMaskToNumberxd(this.formCredito.adelanto));
      } else {
        this.formCredito.precioNuevo = this.formPro.total;
        this.formCredito.collapse1 = false;
      }
    },
    asignarPagos() {
      this.formCredito.pagos = [];
      let cantidad =
        this.precioNuevo / (this.cantidadPagos > 0 ? this.cantidadPagos : 0);
      for (let i = 0; i < this.cantidadPagos; i++) {
        this.formCredito.pagos.push(cantidad.toFixed(2));
      }
    },
    checkboxChange(action) {
      this.$v.$reset();
      if (action == "efectivo" && !this.checkMoney.efectivo) {
        this.cantidad_efectivo = "";
        this.sumarCantidades();
      }

      if (action == "transferencia" && !this.checkMoney.transferencia) {
        this.transferencia = [
          {
            cantidad_transferencia: "",
            transaccion_transferencia: "",
            button: true,
          },
        ];
        this.sumarCantidades();
      }
      if (action == "deposito" && !this.checkMoney.deposito) {
        this.deposito = [
          {
            cantidad_deposito: "",
            transaccion_deposito: "",
            button: true,
          },
        ];
        this.sumarCantidades();
      }

      if (action == "cheque" && !this.checkMoney.cheque) {
        this.cheque = [
          {
            cantidad_cheque: "",
            transaccion_cheque: "",
            button: true,
          },
        ];
        this.sumarCantidades();
      }
      if (action == "tarjeta" && !this.checkMoney.tarjeta) {
        this.cheque = [
          {
            cantidad_tarjeta: "",
            transaccion_tarjeta: "",
            button: true,
          },
        ];
        this.sumarCantidades();
      }
    },
    sumarCantidades() {
      let sum = 0;
      let sum2 = 0;
      let sum3 = 0;
      let sum4 = 0;
      let sum5 = 0;

      if (this.checkMoney.efectivo) {
        sum =
          parseFloat(this.converMaskToNumberxd(this.cantidad_efectivo)) > 0
            ? parseFloat(this.converMaskToNumberxd(this.cantidad_efectivo))
            : 0;
        // this.validarCantidades.efectivo = sum;
      }

      if (this.checkMoney.transferencia) {
        for (let i = 0; i < this.transferencia.length; i++) {
          sum2 =
            sum2 +
            (parseFloat(
              this.converMaskToNumberxd(
                this.transferencia[i].cantidad_transferencia
              )
            ) > 0
              ? parseFloat(
                  this.converMaskToNumberxd(
                    this.transferencia[i].cantidad_transferencia
                  )
                )
              : 0);
        }
      }

      if (this.checkMoney.deposito) {
        for (let i = 0; i < this.deposito.length; i++) {
          sum3 =
            sum3 +
            (parseFloat(
              this.converMaskToNumberxd(this.deposito[i].cantidad_deposito)
            ) > 0
              ? parseFloat(
                  this.converMaskToNumberxd(this.deposito[i].cantidad_deposito)
                )
              : 0);
        }
      }

      if (this.checkMoney.cheque) {
        for (let i = 0; i < this.cheque.length; i++) {
          sum4 =
            sum4 +
            (parseFloat(
              this.converMaskToNumberxd(this.cheque[i].cantidad_cheque)
            ) > 0
              ? parseFloat(
                  this.converMaskToNumberxd(this.cheque[i].cantidad_cheque)
                )
              : 0);
        }
      }

      if (this.checkMoney.tarjeta) {
        for (let i = 0; i < this.tarjeta.length; i++) {
          sum5 =
            sum5 +
            (parseFloat(
              this.converMaskToNumberxd(this.tarjeta[i].cantidad_tarjeta)
            ) > 0
              ? parseFloat(
                  this.converMaskToNumberxd(this.tarjeta[i].cantidad_tarjeta)
                )
              : 0);
        }
      }

      this.montoFinal.cantidad = sum + sum2 + sum3 + sum4 + sum5;

      // if (accion == 1) {
      //   this.montoFinal.cantidad = parseFloat(
      //     this.converMaskToNumberxd(cantidad)
      //   );
      // } else {
      //   this.montoFinal.transaccion = cantidad;
      // }
    },
    cambiarTitulo(cliente) {
      if (cliente) {
        document.title = "Nueva venta | " + cliente.nombre;
      } else {
        document.title = "Nueva venta | Zona Auto";
      }
    },
    asignarPorcentaje() {
      if (parseFloat(this.converMaskToNumberxd(this.porcentaje)) > 0) {
        this.arrayDetalle[this.indexPorcentaje].porcentaje_venta = parseFloat(
          this.converMaskToNumberxd(this.porcentaje)
        );
        this.arrayDetalle[this.indexPorcentaje].precio_original = parseFloat(
          this.precioOriginal
        );
        this.arrayDetalle[this.indexPorcentaje].precio_venta = parseFloat(
          this.precioDescuento
        );
        this.arrayDetalle[this.indexPorcentaje].subtotal =
          (this.arrayDetalle[this.indexPorcentaje].cantidad != ""
            ? this.arrayDetalle[this.indexPorcentaje].cantidad
            : 0.0) *
          (this.arrayDetalle[this.indexPorcentaje].precio_venta != ""
            ? this.arrayDetalle[this.indexPorcentaje].precio_venta
            : 0.0);
      }

      this.$refs["modalPorcentaje"].hide();
    },
    asignarIndex(data) {
      this.indexPorcentaje = data;
      if (this.arrayDetalle[data].porcentaje_venta > 0) {
        this.porcentaje = this.arrayDetalle[data].porcentaje_venta;
      } else {
        this.porcentaje = "";
      }
      this.precioOriginal = this.arrayDetalle[data].precio_venta;
      this.precioDescuento = this.arrayDetalle[data].precio_venta;
    },
    validarExistencia(data) {
      axios
        .get(
          process.env.VUE_APP_URL +
            "productos/existencia_actual?id=" +
            data.item.id2 +
            "&tipo=0",
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
          // console.log(data.item.cantidad, response);
          const existencia = response.data.existencia_disponible;
          if (data.item.cantidad > existencia) {
            // console.log("sobrepasa", data.item.cantidad - existencia);
            Vue.toasted.error(
              `La existencia del producto < ${data.item.producto} > es de ${existencia} unidades`,
              this.options
            );
            if (existencia > 1) {
              data.item.cantidad = 1;
            } else {
              data.item.cantidad = 0;
            }
          }
        });
    },
    cambiarTipo(tipo, numero) {
      if (numero == 1) {
        this.busquedaLabel = tipo;
      } else {
        this.busquedaLabel2 = tipo;
      }
    },
    swCliente() {
      // console.log(this.formPro.proveedor);
      this.formPro.proveedor = null;
    },
    // NUEVAS MODIFICACIONES
    async selectOpc() {
      let me = this;
      // console.log(me.ubicacionModel);
      this.arrayEstante = [];
      try {
        const response = await axios.get(
          process.env.VUE_APP_URL +
            "departamentos/estante/busqueda?departamento=" +
            me.ubicacionModel.id,
          {
            headers: { "x-token": this.userT.token },
          }
        );
        me.arrayEstante = response.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    cambioApiBase() {
      this.apiBase =
        process.env.VUE_APP_URL +
        "productos/nuevo_get?departamento=" +
        this.ubicacionModel.id +
        "&estante=" +
        this.estanteModel.id;
    },
    // fin nuevas modificaciones
    async getDepartamento() {
      const response = await axios.get(
        process.env.VUE_APP_URL +
          "departamentos/busqueda1?id=" +
          this.formPro.tiendaid,
        {
          headers: { "x-token": this.userT.token },
        }
      );
      this.arrayDepa = response.data.ubicacion;
    },
    //AL ABRIR EL MODAL RESETEAR LAS VALIDACIONES Y VARIABLES
    openModal(model) {
      switch (model) {
        case "save": {
          this.$v.formCliente.$reset();
          this.limpiarVariables();

          // console.log("entrando a resetear")
          break;
        }
        case "update": {
          this.$v.$reset();
          break;
        }
        case "productos": {
          this.arrayProductos = [];
          this.producto = "";
          break;
        }
        case "servicios": {
          this.arrayServicios = [];
          this.servicio = "";
          break;
        }
        case "porcentaje": {
          this.indexPorcentaje = 0;
          this.precioOriginal = "";
          this.precioDescuento = "";
          break;
        }
        case "credito": {
          this.formCredito.precioNuevo = this.formPro.total;
          this.formCredito.intervalo = 8;
          this.formCredito.collapse1 = false;
          this.formCredito.pagos = [];
          this.formCredito.adelanto = "0";
          this.formCredito.cantidadPagos = 0;
          break;
        }
      }
    },
    //Variables que necesitan ser limpiadas para los modales
    limpiarVariables() {
      this.formCliente.id = 0;
      this.formCliente.telefono = "";
      this.formCliente.nombre = "";
      this.formCliente.nit = "C/F";
      this.formCliente.direccion = "";
    },
    //Cuanso se cierre el modal por cualquier motivo, cerrar los modadles y en actualizar parar loading
    closeModal(model) {
      switch (model) {
        case "save": {
          this.showModalNP = false;
          this.showmodalL = false;
          break;
        }
        case "update": {
          this.showModalE = false;
          this.showmodalL = false;
          break;
        }
      }
    },
    //Para abrir los modales y pasar los datos de la fila o limpiar valores
    onActionClicked(action) {
      if (action == "new-item") {
        this.limpiarVariables();
      }
    },
    getDatosCliente() {
      this.cambioApiBase();
    },
    async selectCliente(valor) {
      this.arrayCliente = [];
      for (var i = 0; i < this.arrayClientes.length; i++) {
        const estado = this.arrayClientes[i].nombre
          .toLowerCase()
          .includes(valor.toLowerCase());
        if (estado === true) {
          this.arrayCliente.push(this.arrayClientes[i]);
        } else {
          // console.log("nada")
        }
      }
    },
    async gettienda() {
      let me = this;
      me.formPro.tiendaid = "";
      me.formPro.tienda = "";
      axios
        .get(process.env.VUE_APP_URL + "tiendas/select", {
          headers: { "x-token": this.userT.token },
        })
        .then(function (response) {
          me.formPro.tienda = response.data[0].nombre_tienda;
          me.formPro.tiendaid = response.data[0].id;
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {
          this.getDepartamento();
        });
    },
    tomandototal() {
      let temp = 0;
      temp = parseFloat(this.calcularTotal);
      this.formPro.total = temp;
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD +HH:MM");
    },
    //Validaciones antes de guardar
    validaciones(opc) {
      // stop here if form is invalid
      // console.log(this.formPro.proveedor);
      this.$v.$touch();
      if (
        this.formPro.proveedor == "" ||
        this.formPro.tienda == "" ||
        this.formPro.proveedor == null
      ) {
        Vue.toasted.error("Debe agregar un cliente", this.options);
      } else {
        if (
          this.arrayDetalle.length > 0 &&
          this.arrayDetalleServicio.length == 0
        ) {
          if (this.$v.arrayDetalle.$error) {
            Vue.toasted.error("Complete los campos de productos", this.options);
          } else {
            this.showModalL = true;
            if (opc == "save") {
              // console.log("guarda");
              this.save();
            }
          }
        }

        if (
          this.arrayDetalleServicio.length > 0 &&
          this.arrayDetalle.length == 0
        ) {
          if (this.$v.arrayDetalleServicio.$error) {
            Vue.toasted.error("Complete los campos de servicios", this.options);
          } else {
            this.showModalL = true;
            if (opc == "save") {
              // console.log("guarda");
              this.save();
            }
          }
        }

        if (
          this.arrayDetalleServicio.length > 0 &&
          this.arrayDetalle.length > 0
        ) {
          if (
            this.$v.arrayDetalle.$error ||
            this.$v.arrayDetalleServicio.$error
          ) {
            Vue.toasted.error(
              "Complete los campos de productos y servicios",
              this.options
            );
          } else {
            this.showModalL = true;
            if (opc == "save") {
              // console.log("guarda");
              this.save();
            }
          }
        }

        if (
          this.arrayDetalleServicio.length == 0 &&
          this.arrayDetalle.length == 0
        ) {
          Vue.toasted.error("Debe agregar detalles", this.options);
        }
      }
    },
    swNit() {
      if (!this.toggleNit) {
        this.formCliente.nit = "C/F";
      }
      // else {
      //   this.formCliente.nit = "";
      // }
    },
    validacionesCliente(opc) {
      // stop here if form is invalid
      this.$v.formCliente.nombre.$touch();
      this.$v.formCliente.telefono_proveedor.$touch();
      let telC = 0;
      let { nombre, telefono_proveedor } = this.formCliente;

      for (let i = 0; i < telefono_proveedor.length; i++) {
        if (telefono_proveedor[i] == "_" || telefono_proveedor[i] == "") {
          telC++;
        }
      }

      if (nombre != "" && telC == 0) {
        this.showModalL = true;
        if (opc == "save") {
          // console.log("cliente", this.formCliente);
          this.saveCliente();
        }
        if (opc == "update") {
          this.update();
        }
      } else {
        Vue.toasted.error("Complete los datos del cliente", this.options);
      }
    },
    //Guardar registro
    save() {
      this.showModalL = true;
      const { tiendaid, fecha_compra, observaciones, proveedor, total } =
        this.formPro;
      const datos = this.arrayDetalle.map(
        function (item) {
          return {
            cantidad: item.cantidad,
            precio_compra: item.precio_compra,
            precio_original: item.precio_original,
            precio_venta: item.precio_venta,
            subtotal: item.subtotal,
            presentacionId: item.presentacionId,
            porcentaje: item.porcentaje_venta,
            detalle: item.id2,
            id: item.id,
            ubicacion: item.ubicacion,
          };
        },
        {
          headers: { "x-token": this.userT.token },
        }
      );
      const datos2 = this.arrayDetalleServicio.map(function (item) {
        return {
          cantidad: item.cantidad,
          precio_venta: item.precio_venta,
          subtotal: item.subtotal,
          id: item.id,
        };
      });
      axios
        .post(
          process.env.VUE_APP_URL + "ventas/store",
          {
            id: 0,
            fecha_vencimiento: fecha_compra,
            dias_vencimiento: this.fechaVec,
            total_productos: this.calcularProductos,
            total_servicios: this.calcularServicios,
            usuario: this.userT.id,
            tienda: tiendaid,
            cliente: proveedor,
            total,
            observaciones,
            data: datos,
            data2: datos2,
          },
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then(() => {
          Vue.toasted.success("Venta guardada", this.options);
          this.showModalL = false;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
          Vue.toasted.error("Error para guardar", this.options);
        })
        .finally(() => {
          this.showModalL = false;
          this.$router.push({
            name: "ventas",
            shallow: true,
          });
        });
    },
    saveCliente() {
      const { nombre, nit, direccion, telefono_proveedor, correo, cui } =
        this.formCliente;
      const me = this;
      axios
        .post(
          process.env.VUE_APP_URL + "clientes/store",
          {
            nombre,
            nit,
            direccion,
            numero: telefono_proveedor,
            email: correo,
            cui,
          },
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
          Vue.toasted.success(nombre + " Guardado", this.options);
          me.formPro.proveedor = response.data.clientes[0];
          me.getClientes();
          me.$refs.vuetable.refresh();
          this.showModalN = false;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
          Vue.toasted.error("Error para guardar", this.options);
        })
        .finally(() => {
          this.showModalN = false;
        });
    },
    // Funciones para trabajar con detalles
    eliminarDetalle({ index }) {
      let me = this;
      me.arrayDetalle.splice(index, 1);
    },
    eliminarDetalleServicio({ index }) {
      let me = this;
      me.arrayDetalleServicio.splice(index, 1);
    },
    converMaskToNumberxd(number) {
      var myNumber = "";
      for (var i = 0; i < number.length; i += 1) {
        if (
          number.charAt(i) === "Q" ||
          number.charAt(i) === "€" ||
          number.charAt(i) === "$" ||
          number.charAt(i) === "%" ||
          number.charAt(i) === "," ||
          number.charAt(i) === " "
        ) {
          continue;
        } else {
          myNumber += number.charAt(i);
        }
      }
      return parseFloat(myNumber).toFixed(2);
    },
    // Funciones para formatos
    updateporcentaje() {
      const me = this;
      if (parseFloat(me.converMaskToNumberxd(me.porcentaje)) > 100) {
        Vue.toasted.error(
          "El porcentaje de descuento no puede sobrepasar el 100%",
          this.options
        );
        me.porcentaje = "";
        me.precioDescuento = me.precioOriginal;
        return;
      }

      if (me.porcentaje == "") {
        me.precioDescuento = me.precioOriginal;
        return;
      }
      me.precioDescuento =
        parseFloat(me.precioOriginal) -
        (parseFloat(me.converMaskToNumberxd(me.porcentaje)) / 100) *
          parseFloat(me.precioOriginal);

      this.$refs.table.refresh();
    },
    updateDisableDates({ index }) {
      const me = this;
      me.arrayDetalle[index].subtotal =
        (me.arrayDetalle[index].cantidad != ""
          ? me.arrayDetalle[index].cantidad
          : 0.0) *
        (me.arrayDetalle[index].precio_venta != ""
          ? me.arrayDetalle[index].precio_venta
          : 0.0);
      this.$refs.table.refresh();

      // item.no_extras = 0;
    },
    sumarCantidadServicio({ index }) {
      const me = this;
      // console.log(item);
      me.arrayDetalleServicio[index].subtotal =
        (me.arrayDetalleServicio[index].cantidad != ""
          ? me.arrayDetalleServicio[index].cantidad
          : 0.0) *
        (me.arrayDetalleServicio[index].precio_venta != ""
          ? me.arrayDetalleServicio[index].precio_venta
          : 0.0);
      this.$refs.table2.refresh();

      // item.no_extras = 0;
    },
    cambiarPrecioProducto(tipo, data) {
      // console.log(tipo, data);
      this.arrayDetalle[data.index].precio_venta = parseFloat(tipo.cantidad);
      this.arrayDetalle[data.index].porcentaje_venta = 0;
      this.arrayDetalle[data.index].dropdownLabel = tipo.nombre;
      this.arrayDetalle[data.index].subtotal =
        this.arrayDetalle[data.index].cantidad *
        this.arrayDetalle[data.index].precio_venta;
    },
    formatQuetzales(amount) {
      let num = parseFloat(amount),
        formatted;
      formatted = num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
      return (amount = "Q " + formatted);
    },
    getLabel: function (val) {
      return val.nombre_departamento;
    },
    getLabel1: function (val) {
      return this.ubicacionModel.estado_tipo == 1
        ? val.nombre_estante
        : val.nombre_pasillo;
    },
    // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    showDate(date) {
      return moment(date).locale("es").utc().format("MMM Do YYYY");
    },
    trasladoDetalle() {
      const me = this;
      axios
        .get(
          process.env.VUE_APP_URL +
            "productos/stock/busqueda_compras?departamento=" +
            this.ubicacionModel.id +
            "&estante=" +
            this.estanteModel.id +
            "&activador=" +
            this.activa_proveedor +
            "&proveedor=" +
            this.formPro.proveedor.id,
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
          this.arrayDet = response.data.data;
        })
        .catch((response) => {
          console.log(response);
        })
        .finally(() => {
          for (let i = 0; i < this.arrayDet.length; i++) {
            if (this.traslado_masivo == true) {
              if (this.encuentra(this.arrayDet[i].Stock.id)) continue;
              me.arrayDetalle.push({
                precio_compra: this.arrayDet[i].Stock.precio_compra_stock,
                precio_venta: this.arrayDet[i].Stock.precio_venta_stock,
                presentacionId: this.arrayDet[i].Stock.presentacioneId,
                presentacion:
                  this.arrayDet[i].Stock.presentacione.nombre_presentacion,
                id: this.arrayDet[i].Stock.id,
                ubicacion: this.arrayDet[i].departamentoId,
                producto: this.arrayDet[i].Stock.producto.nombre_producto,
                cantidad: "",
                subtotal: 0,
              });
            } else {
              me.arrayDetalle.splice(me.arrayDetalle.length - 1);
            }
          }
        });
    },
    agregarDetalle(data) {
      const me = this;
      // console.log(data);
      me.arrayDetalle.push({
        dropdownLabel: "Precio venta",
        tipos_precio: [
          {
            cantidad: data.Stock.precio_mayoreo_stock,
            nombre: "Precio mayoreo",
          },
          {
            cantidad: data.Stock.precio_taller_stock,
            nombre: "Precio taller",
          },
          { cantidad: data.Stock.precio_venta_stock, nombre: "Precio venta" },
        ],
        precio_compra: data.Stock.precio_compra_stock,
        precio_original: 0,
        precio_venta: data.Stock.precio_venta_stock,
        presentacionId: data.Stock.presentacioneId,
        presentacion: data.Stock.presentacione.nombre_presentacion,
        id: data.Stock.id,
        id2: data.id,
        codigo: data.Stock.codigo_stock,
        departamento: data.departamento.nombre_departamento,
        estante:
          data.estante.nombre_pasillo == ""
            ? data.estante.nombre_estante
            : data.estante.nombre_pasillo,
        ubicacion: data.departamentoId,
        producto: data.Stock.producto.nombre_producto,
        cantidad: 1,
        porcentaje_venta: 0,
        subtotal: data.Stock.precio_venta_stock,
      });
      this.producto = null;
      // console.log(me.arrayDetalle);
    },
    agregarDetalleServicio(data) {
      // console.log(data);
      this.arrayDetalleServicio.push({
        nombre_servicio: data.nombre_servicio,
        descripcion_servicio: data.descripcion_servicio,
        cantidad: 1,
        subtotal: 0,
        precio_venta: 0,
        id: data.id,
      });
      // console.log(this.arrayDetalleServicio);
    },
    verificarstock(stock) {
      const me = this;
      if (me.encuentra(stock["id"].toString())) {
        return true;
      }
    },
    verificarServicio(stock) {
      const me = this;
      // console.log(stock)
      if (me.encuentra2(stock["id"].toString())) {
        return true;
      }
    },
    // Esta función encuentra si en el detatalle ya esta la habitacion
    encuentra(id) {
      let sw = 0;
      for (var i = 0; i < this.arrayDetalle.length; i++) {
        if (this.arrayDetalle[i].id2.toString() == id) {
          sw = true;
        }
      }
      return sw;
    },
    encuentra2(id) {
      let sw = 0;
      for (var i = 0; i < this.arrayDetalleServicio.length; i++) {
        if (this.arrayDetalleServicio[i].id.toString() == id) {
          sw = true;
        }
      }
      return sw;
    },
    async getClientes() {
      this.arrayClientes = [];
      try {
        const response = await axios.get(
          process.env.VUE_APP_URL + "clientes/busqueda",
          {
            headers: { "x-token": this.userT.token },
          }
        );
        this.arrayClientes = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getProductos(producto) {
      this.arrayProductos = [];
      if (producto == "" || producto == " ") {
        this.arrayProductos = [];
        return;
      } else {
        try {
          const response = await axios.get(
            process.env.VUE_APP_URL +
              `productos/nueva_busqueda?criterio=${this.busquedaLabel.value}&search=${producto}`,
            {
              headers: { "x-token": this.userT.token },
            }
          );
          this.arrayProductos = response.data.data;
          // console.log(this.arrayProductos);
        } catch (error) {
          console.log(error);
        }
      }
    },
    async getServicios(servicio) {
      this.arrayServicios = [];
      if (servicio == "" || servicio == " ") {
        return;
      } else {
        const response = await axios.get(
          process.env.VUE_APP_URL + `servicios/select?search=${servicio}`,
          {
            headers: { "x-token": this.userT.token },
          }
        );
        this.arrayServicios = response.data.data;
      }
    },
    async getFechaVec() {
      this.fechaVec = "";
      try {
        const response = await axios.get(
          process.env.VUE_APP_URL + "configuraciones/get",
          {
            headers: { "x-token": this.userT.token },
          }
        );
        this.fechaVec = response.data.data[0].dias_disponibles;

        this.formPro.fecha_compra = moment(this.formPro.fecha_compra).add(
          this.fechaVec,
          "d"
        );
        // console.log(this.formPro.fecha_compra);
      } catch (error) {
        console.log(error);
      }
    },

    //Buscador dentro de la tabala
    onFiltered() {
      this.search = this.search.toLowerCase();
      this.$refs.vuetable.refresh();
    },
    onFiltered2() {
      this.search2 = this.search2.toLowerCase();
      this.$refs.vuetable2.refresh();
    },
    //enviar datos a la Paginacion
    onPaginationData(paginationData) {
      this.to = paginationData.to;
      this.total = paginationData.total;
      this.lastPage = paginationData.last_page;
      // this.items = paginationData.data;
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onPaginationData2(paginationData) {
      this.to2 = paginationData.to;
      this.total2 = paginationData.total;
      this.lastPage2 = paginationData.last_page;
      // this.items = paginationData.data;
      this.$refs.pagination2.setPaginationData(paginationData);
    },
    //Cambiar tamaño de filas en la tabala para mostrar
    changePageSize() {
      this.$refs.vuetable.refresh();
    },
    changePageSize2() {
      this.$refs.vuetable2.refresh();
    },

    // Cambiar el valor del dropwdown para poder filtrar
    changeTypeSearch(type) {
      this.searchLabel = type;
      this.$refs.vuetable.refresh();
    },
    changeTypeSearch2(type) {
      this.searchLabel2 = type;
      this.$refs.vuetable2.refresh();
    },
    //Cuando cambia de pagina
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },

    onChangePage2(page) {
      this.$refs.vuetable2.changePage(page);
    },
    //Query para realizar busquedas y ordenar
    makeQueryParams(sortOrder, currentPage) {
      return sortOrder[0]
        ? {
            criterio: sortOrder[0]
              ? sortOrder[0].sortField
              : this.searchLabel.value,

            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
          }
        : {
            criterio: sortOrder[0]
              ? sortOrder[0].sortField
              : this.searchLabel.value,

            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
          };
    },
    makeQueryParams2(sortOrder, currentPage) {
      return sortOrder[0]
        ? {
            criterio: sortOrder[0] ? sortOrder[0].sortField : "nombre_persona",
            categoria: this.searchLabel2.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search2,
          }
        : {
            criterio: sortOrder[0] ? sortOrder[0].sortField : "nombre_persona",
            categoria: this.searchLabel2.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search2,
          };
    },
  },
};
</script>

<template>
  <Layout>
    <!-- Modal de Nuevo Cliente-->
    <b-modal
      centered
      @show="openModal('save')"
      @hidden="openModal('save')"
      v-model="showModalN"
      id="modalCliente"
      ref="modalCliente"
      title="Nuevo cliente"
      title-class="text-black font-18"
      body-class="p-3"
      hide-footer
    >
      <form>
        <!-- Nombre -->
        <div class="col-12">
          <div class="mb-3">
            <label for="name">Nombre</label>
            <input
              id="name"
              v-model="$v.formCliente.nombre.$model"
              type="text"
              class="form-control"
              placeholder="Ingrese un nombre"
              :class="{
                'is-invalid': $v.formCliente.nombre.$error,
              }"
              @input="$v.formCliente.nombre.$touch()"
            />
            <div
              v-if="
                $v.formCliente.nombre.$error && !$v.formCliente.nombre.required
              "
              class="invalid-feedback"
            >
              El nombre es obligatorio.
            </div>
          </div>
        </div>
        <!-- Identificacion -->
        <div class="col-12">
          <div class="mb-3">
            <label for="phone">Identificación</label>
            <masked-input
              v-model.trim="formCliente.cui"
              :mask="[
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                ' ',
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                ' ',
                /\d/,
                /\d/,
                /\d/,
                /\d/,
              ]"
              class="form-control"
              placeholder="Ingrese CUI"
            />
          </div>
        </div>
        <!-- Nit -->
        <div class="col-12">
          <div class="mb-3">
            <div class="row">
              <div class="col">
                <p>Nit</p>
                <switches
                  v-model="toggleNit"
                  class="ms-1"
                  @input="swNit"
                ></switches>
              </div>
              <div class="col"></div>
            </div>
            <div v-if="!toggleNit">
              <input
                disabled
                v-model.trim="$v.formCliente.nit.$model"
                type="text"
                class="form-control"
                placeholder="C/F"
              />
            </div>
            <div v-if="toggleNit">
              <input
                v-model.trim="$v.formCliente.nit.$model"
                :class="{ 'is-invalid': $v.formCliente.nit.$error }"
                type="text"
                class="form-control"
                placeholder="Ingrese NIT"
                @input="$v.formCliente.nit.$touch()"
              />
              <div
                v-if="$v.formCliente.nit.$error && !$v.formCliente.nit.required"
                :class="{
                  'invalid-feedback': true,
                  'd-block':
                    $v.formCliente.nit.$error && !$v.formCliente.nit.required,
                }"
              >
                El NIT es requerido
              </div>
              <div class="alert alert-danger" v-if="!$v.formCliente.nit.nit">
                El número de NIT no es valido.
              </div>
            </div>
          </div>
        </div>
        <!-- Telefono -->
        <div class="col-12">
          <div class="mb-3">
            <label for="name">Teléfono</label>
            <masked-input
              v-model.trim="formCliente.telefono_proveedor"
              :class="{
                'is-invalid': $v.formCliente.telefono_proveedor.$error,
              }"
              :state="!$v.formCliente.telefono_proveedor.$error"
              :mask="[/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
              class="form-control"
              placeholder="Ingrese el número de teléfono"
            />
            <div
              :class="{
                'invalid-feedback': true,
                'd-block':
                  $v.formCliente.telefono_proveedor.$error &&
                  !$v.formCliente.telefono_proveedor.required,
              }"
            >
              Telefono Requerido
            </div>
          </div>
        </div>
        <!-- Direccion -->
        <div class="col-12">
          <div class="mb-3">
            <label for="phone">Dirección del contacto</label>
            <input
              id="phone"
              v-model.trim="$v.formCliente.direccion.$model"
              :state="!$v.formCliente.direccion.$error"
              :class="{
                'is-invalid': $v.formCliente.direccion.$error,
              }"
              type="text"
              class="form-control"
              placeholder="Ingrese Dirección"
            />
            <div
              :class="{
                'invalid-feedback': true,
                'd-block':
                  $v.formCliente.direccion.$error &&
                  !$v.formCliente.direccion.required,
              }"
            >
              Dirección Requerida
            </div>
          </div>
        </div>
        <!-- Correo -->
        <div class="col-12">
          <div class="mb-3">
            <label for="correo">Correo</label>
            <input
              id="correo"
              v-model.trim="formCliente.correo"
              :state="!$v.formCliente.correo.$error"
              :class="{
                'is-invalid': $v.formCliente.correo.$error,
              }"
              type="email"
              class="form-control"
              placeholder="Ingrese Correo"
              @input="$v.formCliente.correo.$touch()"
            />
            <div v-if="$v.formCliente.correo.$error">
              <div class="alert alert-danger" v-if="!$v.formCliente.correo.nit">
                El correo es inválido
              </div>
            </div>
          </div>
        </div>
        <!-- Botones -->
        <div class="text-end pt-5 mt-3">
          <b-button variant="light" @click="showModalN = false"
            >Cerrar</b-button
          >
          <b-button
            @click="validacionesCliente('save')"
            variant="success"
            class="ms-1"
            >Guardar</b-button
          >
        </div>
      </form>
    </b-modal>

    <!-- Modal productos -->
    <b-modal
      centered
      @show="openModal('productos')"
      @hidden="openModal('productos')"
      id="modalProductos"
      ref="modalProductos"
      title="Productos"
      size="lg"
      title-class="text-black font-18"
      body-class="p-3"
    >
      <b-form-group>
        <b-input-group>
          <b-dropdown variant="secondary" size="sm">
            <template v-slot:button-content>
              {{ busquedaLabel.nombre }}
              <i class="mdi mdi-chevron-down"></i>
            </template>
            <b-dropdown-item
              v-for="(search, index) in busquedaTipos"
              :key="index"
              @click="cambiarTipo(search, 1)"
              >{{ search.nombre }}</b-dropdown-item
            >
          </b-dropdown>
          <b-input
            v-model="producto"
            placeholder="Ingrese el código o nombre del producto"
            @input="getProductos(producto)"
          >
          </b-input>
        </b-input-group>
      </b-form-group>

      <b-table striped :items="arrayProductos" :fields="fieldsProductos">
        <template #cell(action)="data">
          <b-button
            v-if="verificarstock(data.item) != true"
            @click="agregarDetalle(data.item)"
            variant="outline-primary"
            ><i class="bx bx-plus-medical"></i
          ></b-button>
        </template>
        <template #cell(producto)="data">
          {{ data.item.Stock.producto.nombre_producto }}
        </template>
        <template #cell(codigo)="data">
          {{ data.item.Stock.codigo_stock }}
        </template>
        <template #cell(existencia)="data">
          {{ data.item.existencia_departamento }}
        </template>
        <template #cell(departamento)="data">
          {{ data.item.departamento.nombre_departamento }}
        </template>
        <template #cell(estante)="data">
          {{
            data.item.estante.nombre_estante == ""
              ? data.item.estante.nombre_pasillo
              : data.item.estante.nombre_estante
          }}
        </template>
        <template #cell(precio_venta)="data">
          {{ money(data.item.Stock.precio_venta_stock) }}
        </template>
      </b-table>

      <template #modal-footer="{}">
        <b-button variant="danger" @click="$bvModal.hide('modalProductos')"
          >Cerrar</b-button
        >
      </template>
    </b-modal>

    <!-- Modal servicios -->
    <b-modal
      centered
      @show="openModal('servicios')"
      @hidden="openModal('servicios')"
      id="modalServicios"
      ref="modalServicios"
      title="Servicios"
      size="lg"
      title-class="text-black font-18"
      body-class="p-3"
    >
      <b-input
        v-model="servicio"
        placeholder="Ingrese el nombre del servicio"
        @input="getServicios(servicio)"
      >
      </b-input>
      <b-table striped :items="arrayServicios" :fields="fieldsServicios">
        <template #cell(action)="data">
          <b-button
            v-if="verificarServicio(data.item) != true"
            @click="agregarDetalleServicio(data.item)"
            variant="outline-primary"
            ><i class="bx bx-plus-medical"></i
          ></b-button>
        </template>
      </b-table>

      <template #modal-footer="{}">
        <b-button variant="danger" @click="$bvModal.hide('modalServicios')"
          >Cerrar</b-button
        >
      </template>
    </b-modal>

    <!-- Modal porcentaje -->
    <b-modal
      centered
      @hidden="openModal('porcentaje')"
      id="modalPorcentaje"
      ref="modalPorcentaje"
      title="Asigar porcentaje de descuento"
      title-class="text-black font-18"
      body-class="p-3"
    >
      <div v-if="arrayDetalle.length > 0">
        <h3>Precio normal</h3>
        <h5>{{ money(precioOriginal) }}</h5>
        <br />
        <h3>Nuevo precio</h3>
        <h5>
          {{ money(precioDescuento) }}
        </h5>
        <br />
        <h3>Descuento</h3>

        <masked-input
          v-model="porcentaje"
          @input="updateporcentaje()"
          :mask="mask_porcentaje"
          class="form-control"
          placeholder="Ingrese el porcentaje de descuento"
        />
      </div>

      <template #modal-footer="{}">
        <b-button variant="primary" @click="asignarPorcentaje"
          >Asignar descuento</b-button
        >
        <b-button variant="danger" @click="$bvModal.hide('modalPorcentaje')"
          >Cerrar</b-button
        >
      </template>
    </b-modal>

    <!-- Modal porcentaje -->
    <b-modal
      centered
      @show="openModal('credito')"
      id="modalCredito"
      ref="modalCredito"
      size="xl"
      title="Asignar crédito"
      title-class="text-black font-18"
      body-class="p-3"
    >
      <b-card>
        <div class="row">
          <div class="col">
            <b-card bg-variant="primary bg-soft">
              <div class="row">
                <div class="col">
                  <h5>Precio original</h5>
                  <h5>{{ money(formPro.total) }}</h5>
                </div>
                <div class="col">
                  <h5>Con adelanto</h5>
                  <h5>{{ money(formCredito.precioNuevo) }}</h5>
                </div>
              </div>
              <br />
              <label for="name">Adelanto</label>
              <masked-input
                v-model.trim="formCredito.adelanto"
                :mask="mask_quetzal"
                :guide="false"
                :keep-char-positions="true"
                :show-mask="true"
                type="text"
                @input="asignarAdelanto()"
                placeholder="Ingresar el monto de adelanto"
                class="form-control"
              />
              <br />
              <label for="name">Cantidad de pagos</label>
              <b-input
                type="number"
                v-model="formCredito.cantidadPagos"
                placeholder="Ingrese la cantidad de pagos"
              />
              <br />
              <label for="name">Fecha inicio de pagos</label>
              <date-picker
                v-model="formCredito.fechaInicio"
                :first-day-of-week="1"
                lang="es"
              ></date-picker>
              <br /><br />
              <label for="name">Intervalo de días para pago</label>
              <b-input
                type="number"
                v-model="formCredito.intervalo"
                placeholder="Ingrese la cantidad de pagos"
              />
              <br />
              <b-button @click="asignarCredito">CÁLCULAR CRÉDITO</b-button>
            </b-card>
          </div>
          <div class="col" style="max-height: 485px; overflow-y: auto">
            <b-card bg-variant="primary bg-soft">
              <h5>Distribución de pagos</h5>
              <div v-for="(pago, index) in formCredito.pagos" :key="index">
                <b-card no-body>
                  <h5 style="margin-top: 10px">
                    &nbsp;&nbsp;<span class="badge badge-pill bg-primary ms-1"
                      ><strong>{{ index + 1 }}</strong></span
                    >
                    {{ money(pago) }}
                  </h5>
                </b-card>
              </div>
            </b-card>
          </div>
        </div>
        <b-collapse v-model="formCredito.collapse1" visible class="mt-1">
          <b-tabs pills vertical nav-wrapper-class="col-sm-4">
            <!-- Efectivo -->
            <b-tab :disabled="checkSelect.efectivo">
              <template v-slot:title>
                <b-form-checkbox v-model="checkMoney.efectivo">
                  &nbsp;&nbsp;<span class="d-none d-sm-inline-block">
                    Efectivo</span
                  >&nbsp;
                  <i class="fas fa-money-bill"> </i>
                </b-form-checkbox>
              </template>

              <b-card bg-variant="primary bg-soft">
                <b-form-checkbox
                  v-model="checkMoney.efectivo"
                  @input="checkboxChange('efectivo')"
                  >&nbsp;&nbsp;Usar método de pago
                </b-form-checkbox>
                <br />
                <b-form-group label="MONTO">
                  <masked-input
                    :disabled="!checkMoney.efectivo"
                    v-model.trim="$v.cantidad_efectivo.$model"
                    :mask="mask_quetzal"
                    :guide="false"
                    :keep-char-positions="true"
                    :show-mask="true"
                    type="text"
                    @input="sumarCantidades()"
                    placeholder="Ingresar el monto a pagar"
                    :class="{
                      'is-invalid': $v.cantidad_efectivo.$error,
                    }"
                    class="form-control"
                  />
                  <div
                    v-if="checkMoney.efectivo"
                    :class="{
                      'invalid-feedback': true,
                      'd-block':
                        $v.cantidad_efectivo.$invalid &&
                        !$v.cantidad_efectivo.$invalid.required,
                    }"
                  >
                    Debe ingresar el monto
                  </div>
                  <!-- <div
                    v-if="validarCantidades.efectivo <= 0"
                    :class="{
                      'invalid-feedback': true,
                      'd-block':
                        $v.validarCantidades.efectivo.$error &&
                        !$v.validarCantidades.efectivo.minValue,
                    }"
                  >
                    La cantidad debe ser mayor a cero
                  </div> -->
                </b-form-group>
              </b-card>
            </b-tab>
            <!-- Transferencia -->
            <b-tab :disabled="checkSelect.transferencia">
              <template v-slot:title>
                <b-form-checkbox v-model="checkMoney.transferencia">
                  &nbsp;&nbsp;<span class="d-none d-sm-inline-block">
                    Transferencia</span
                  >&nbsp;
                  <i class="bx bx-transfer-alt"> </i>
                </b-form-checkbox>
              </template>

              <b-card bg-variant="primary bg-soft">
                <b-form-checkbox
                  v-model="checkMoney.transferencia"
                  @input="checkboxChange('transferencia')"
                >
                  &nbsp;&nbsp;Usar método de pago
                </b-form-checkbox>
                <br />
                <div v-for="(item, index) in transferencia" v-bind:key="index">
                  <b-form-group
                    :label="'NÚMERO DE TRANSACCIÓN' + ' ' + (index + 1)"
                    class="has-float-label"
                  >
                    <b-input-group>
                      <b-form-input
                        :disabled="!checkMoney.transferencia"
                        :class="{
                          'is-invalid':
                            $v.transferencia.$each.$iter[index]
                              .transaccion_transferencia.$error,
                        }"
                        v-model.trim="item.transaccion_transferencia"
                        placeholder="Ingresar en número de transacción"
                        @input="sumarCantidades()"
                      >
                      </b-form-input>
                      <b-input-group-append v-if="item.button">
                        <b-button
                          :disabled="!checkMoney.transferencia"
                          variant="primary"
                          @click="onButton('transferencia-plus')"
                          ><i :class="'bx bx-plus-medical'"
                        /></b-button>
                      </b-input-group-append>
                      <b-input-group-append v-if="!item.button">
                        <b-button
                          variant="primary"
                          @click="onButton('transferencia-minus', index)"
                          ><i :class="'bx bx-undo'"
                        /></b-button>
                      </b-input-group-append>
                    </b-input-group>
                    <div
                      v-if="checkMoney.transferencia"
                      :class="{
                        'invalid-feedback': true,
                        'd-block':
                          $v.transferencia.$each.$iter[index]
                            .transaccion_transferencia.$invalid &&
                          !$v.transferencia.$each.$iter[index]
                            .transaccion_transferencia.$invalid.required,
                      }"
                    >
                      Debe ingresar el número de transacción
                    </div>
                  </b-form-group>
                  <br />
                  <b-form-group label="MONTO">
                    <masked-input
                      :disabled="!checkMoney.transferencia"
                      v-model.trim="item.cantidad_transferencia"
                      :mask="mask_quetzal"
                      :guide="false"
                      :keep-char-positions="true"
                      :show-mask="true"
                      type="text"
                      @input="sumarCantidades()"
                      placeholder="Ingresar el monto a pagar"
                      :class="{
                        'is-invalid':
                          $v.transferencia.$each.$iter[index]
                            .cantidad_transferencia.$error,
                      }"
                      class="form-control"
                    />
                    <div
                      v-if="checkMoney.transferencia"
                      :class="{
                        'invalid-feedback': true,
                        'd-block':
                          $v.transferencia.$each.$iter[index]
                            .cantidad_transferencia.$invalid &&
                          !$v.transferencia.$each.$iter[index]
                            .cantidad_transferencia.$invalid.required,
                      }"
                    >
                      Debe ingresar el monto
                    </div>
                  </b-form-group>
                  <hr />
                </div>
              </b-card>
            </b-tab>
            <!-- Deposito -->
            <b-tab :disabled="checkSelect.deposito">
              <template v-slot:title>
                <b-form-checkbox v-model="checkMoney.deposito">
                  &nbsp;&nbsp;<span class="d-none d-sm-inline-block">
                    Deposito</span
                  >&nbsp;
                  <i class="bx bxs-downvote"> </i>
                </b-form-checkbox>
              </template>

              <b-card bg-variant="primary bg-soft">
                <b-form-checkbox
                  v-model="checkMoney.deposito"
                  @input="checkboxChange('deposito')"
                  >&nbsp;&nbsp;Usar método de pago
                </b-form-checkbox>
                <br />
                <div v-for="(item, index) in deposito" v-bind:key="index">
                  <b-form-group
                    :label="'NÚMERO DE DEPOSITO' + ' ' + (index + 1)"
                    class="has-float-label"
                  >
                    <b-input-group>
                      <b-form-input
                        :disabled="!checkMoney.deposito"
                        :class="{
                          'is-invalid':
                            $v.deposito.$each.$iter[index].transaccion_deposito
                              .$error,
                        }"
                        v-model.trim="item.transaccion_deposito"
                        placeholder="Ingresar en número deposito"
                        @input="sumarCantidades()"
                      >
                      </b-form-input>
                      <b-input-group-append v-if="item.button">
                        <b-button
                          :disabled="!checkMoney.deposito"
                          variant="primary"
                          @click="onButton('deposito-plus')"
                        >
                          <i :class="'bx bx-plus-medical'" />
                        </b-button>
                      </b-input-group-append>
                      <b-input-group-append v-if="!item.button">
                        <b-button
                          variant="primary"
                          @click="onButton('deposito-minus', index)"
                          ><i :class="'bx bx-undo'"
                        /></b-button>
                      </b-input-group-append>
                    </b-input-group>
                    <div
                      v-if="checkMoney.deposito"
                      :class="{
                        'invalid-feedback': true,
                        'd-block':
                          $v.deposito.$each.$iter[index].transaccion_deposito
                            .$invalid &&
                          !$v.deposito.$each.$iter[index].transaccion_deposito
                            .$invalid.required,
                      }"
                    >
                      Debe ingresar el número de deposito
                    </div>
                  </b-form-group>
                  <br />
                  <b-form-group label="MONTO">
                    <masked-input
                      :disabled="!checkMoney.deposito"
                      v-model.trim="item.cantidad_deposito"
                      :mask="mask_quetzal"
                      :guide="false"
                      :keep-char-positions="true"
                      :show-mask="true"
                      type="text"
                      @input="sumarCantidades()"
                      placeholder="Ingresar el monto a pagar"
                      :class="{
                        'is-invalid':
                          $v.deposito.$each.$iter[index].cantidad_deposito
                            .$error,
                      }"
                      class="form-control"
                    />
                    <div
                      v-if="checkMoney.deposito"
                      :class="{
                        'invalid-feedback': true,
                        'd-block':
                          $v.deposito.$each.$iter[index].cantidad_deposito
                            .$invalid &&
                          !$v.deposito.$each.$iter[index].cantidad_deposito
                            .$invalid.required,
                      }"
                    >
                      Debe ingresar el monto
                    </div>
                  </b-form-group>
                  <hr />
                </div>
              </b-card>
            </b-tab>
            <!-- Cheque -->
            <b-tab :disabled="checkSelect.cheque">
              <template v-slot:title>
                <b-form-checkbox v-model="checkMoney.cheque">
                  &nbsp;&nbsp;<span class="d-none d-sm-inline-block">
                    Cheque</span
                  >&nbsp;
                  <i class="bx bx-dock-top"> </i>
                </b-form-checkbox>
              </template>

              <b-card bg-variant="primary bg-soft">
                <b-form-checkbox
                  v-model="checkMoney.cheque"
                  @input="checkboxChange('cheque')"
                  >&nbsp;&nbsp;Usar método de pago
                </b-form-checkbox>
                <br />
                <div v-for="(item, index) in cheque" v-bind:key="index">
                  <b-form-group
                    :label="'NÚMERO DE CHEQUE' + ' ' + (index + 1)"
                    class="has-float-label"
                  >
                    <b-input-group>
                      <b-form-input
                        :disabled="!checkMoney.cheque"
                        :class="{
                          'is-invalid':
                            $v.cheque.$each.$iter[index].transaccion_cheque
                              .$error,
                        }"
                        v-model.trim="item.transaccion_cheque"
                        placeholder="Ingresar en número dcheque"
                        @input="sumarCantidades()"
                      >
                      </b-form-input>
                      <b-input-group-append v-if="item.button">
                        <b-button
                          :disabled="!checkMoney.cheque"
                          variant="primary"
                          @click="onButton('cheque-plus')"
                          ><i :class="'bx bx-plus-medical'"
                        /></b-button>
                      </b-input-group-append>
                      <b-input-group-append v-if="!item.button">
                        <b-button
                          variant="primary"
                          @click="onButton('cheque-minus', index)"
                          ><i :class="'bx bx-undo'" />
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                    <div
                      v-if="checkMoney.cheque"
                      :class="{
                        'invalid-feedback': true,
                        'd-block':
                          $v.cheque.$each.$iter[index].transaccion_cheque
                            .$invalid &&
                          !$v.cheque.$each.$iter[index].transaccion_cheque
                            .$invalid.required,
                      }"
                    >
                      Debe ingresar el número dcheque
                    </div>
                  </b-form-group>
                  <br />
                  <b-form-group label="MONTO">
                    <masked-input
                      :disabled="!checkMoney.cheque"
                      v-model.trim="item.cantidad_cheque"
                      :mask="mask_quetzal"
                      :guide="false"
                      :keep-char-positions="true"
                      :show-mask="true"
                      type="text"
                      @input="sumarCantidades()"
                      placeholder="Ingresar el monto a pagar"
                      :class="{
                        'is-invalid':
                          $v.cheque.$each.$iter[index].cantidad_cheque.$error,
                      }"
                      class="form-control"
                    />
                    <div
                      v-if="checkMoney.cheque"
                      :class="{
                        'invalid-feedback': true,
                        'd-block':
                          $v.cheque.$each.$iter[index].cantidad_cheque
                            .$invalid &&
                          !$v.cheque.$each.$iter[index].cantidad_cheque.$invalid
                            .required,
                      }"
                    >
                      Debe ingresar el monto
                    </div>
                  </b-form-group>
                  <hr />
                </div>
              </b-card>
            </b-tab>
            <!-- Tarjeta -->
            <b-tab :disabled="checkSelect.tarjeta">
              <template v-slot:title>
                <b-form-checkbox v-model="checkMoney.tarjeta">
                  &nbsp;&nbsp;<span class="d-none d-sm-inline-block">
                    Tarjeta</span
                  >&nbsp;
                  <i class="far fa-credit-card"> </i>
                </b-form-checkbox>
              </template>

              <b-card bg-variant="primary bg-soft">
                <b-form-checkbox
                  v-model="checkMoney.tarjeta"
                  @input="checkboxChange('tarjeta')"
                  >&nbsp;&nbsp;Usar método de pago
                </b-form-checkbox>
                <br />
                <div v-for="(item, index) in tarjeta" v-bind:key="index">
                  <b-form-group
                    :label="'NÚMERO DE TRANSACCIÓN TARJETA' + ' ' + (index + 1)"
                    class="has-float-label"
                  >
                    <b-input-group>
                      <b-form-input
                        :disabled="!checkMoney.tarjeta"
                        :class="{
                          'is-invalid':
                            $v.tarjeta.$each.$iter[index].transaccion_tarjeta
                              .$error,
                        }"
                        v-model.trim="item.transaccion_tarjeta"
                        placeholder="Ingresar en número tarjeta"
                        @input="sumarCantidades()"
                      >
                      </b-form-input>
                      <b-input-group-append v-if="item.button">
                        <b-button
                          :disabled="!checkMoney.tarjeta"
                          variant="primary"
                          @click="onButton('tarjeta-plus')"
                          ><i :class="'bx bx-plus-medical'"
                        /></b-button>
                      </b-input-group-append>
                      <b-input-group-append v-if="!item.button">
                        <b-button
                          variant="primary"
                          @click="onButton('tarjeta-minus', index)"
                          ><i :class="'bx bx-undo'"
                        /></b-button>
                      </b-input-group-append>
                    </b-input-group>
                    <div
                      v-if="checkMoney.tarjeta"
                      :class="{
                        'invalid-feedback': true,
                        'd-block':
                          $v.tarjeta.$each.$iter[index].transaccion_tarjeta
                            .$invalid &&
                          !$v.tarjeta.$each.$iter[index].transaccion_tarjeta
                            .$invalid.required,
                      }"
                    >
                      Debe ingresar el número de transacción de tarjeta
                    </div>
                  </b-form-group>
                  <br />
                  <b-form-group label="MONTO">
                    <masked-input
                      :disabled="!checkMoney.tarjeta"
                      v-model.trim="item.cantidad_tarjeta"
                      :mask="mask_quetzal"
                      :guide="false"
                      :keep-char-positions="true"
                      :show-mask="true"
                      type="text"
                      @input="sumarCantidades()"
                      placeholder="Ingresar el monto a pagar"
                      :class="{
                        'is-invalid':
                          $v.tarjeta.$each.$iter[index].cantidad_tarjeta.$error,
                      }"
                      class="form-control"
                    />
                    <div
                      v-if="checkMoney.tarjeta"
                      :class="{
                        'invalid-feedback': true,
                        'd-block':
                          $v.tarjeta.$each.$iter[index].cantidad_tarjeta
                            .$invalid &&
                          !$v.tarjeta.$each.$iter[index].cantidad_tarjeta
                            .$invalid.required,
                      }"
                    >
                      Debe ingresar el monto
                    </div>
                  </b-form-group>
                  <hr />
                </div>
              </b-card>
            </b-tab>
          </b-tabs>
          <br />
          <div class="row">
            <div class="col">
              <b-card bg-variant="primary" class="text-white-50 bg-gradient">
                <h4 class="mt-0 mb-4 text-white">
                  <i class="bx bx-money me-3"></i> Total a pagar
                </h4>
                <h3 class="mt-0 mb-4 text-white" align="center">
                  {{ money(formPro.total > 0 ? formPro.total : 0.0) }}
                </h3>
              </b-card>
            </div>
            <div class="col">
              <b-card bg-variant="primary" class="text-white-50 bg-gradient">
                <h4 class="mt-0 mb-4 text-white">
                  <i class="bx bx-list-check me-3"></i> Restante de pago
                </h4>
                <h3 class="mt-0 mb-4 text-white" align="center">
                  {{
                    money(
                      formPro.total > 0
                        ? formPro.total - montoFinal.cantidad
                        : 0.0
                    )
                  }}
                </h3>
              </b-card>
            </div>
            <div class="col">
              <b-card bg-variant="primary" class="text-white-50 bg-gradient">
                <h4 class="mt-0 mb-4 text-white">
                  <i class="bx bx-detail me-3"></i> Cantidad pagando
                </h4>
                <h3 class="mt-0 mb-4 text-white" align="center">
                  {{
                    money(montoFinal.cantidad >= 0 ? montoFinal.cantidad : 0.0)
                  }}
                </h3>
              </b-card>
            </div>
          </div>
        </b-collapse>
      </b-card>

      <template #modal-footer="{}">
        <b-button variant="primary" @click="asignarPorcentaje"
          >Aceptar</b-button
        >
        <b-button variant="danger" @click="$bvModal.hide('modalCredito')"
          >Cerrar</b-button
        >
      </template>
    </b-modal>

    <!-- Modal credito -->

    <b-modal
      centered
      v-model="showModalL"
      title-class="text-black font-18"
      body-class="p-3"
      hide-footer
      no-close-on-backdrop
      content-class="my-class"
      header-class="my-class"
    >
      <template #modal-header="{}">
        <!-- Emulate built in modal header close button action -->

        <h5></h5>
      </template>
      <form>
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-center">
              <fulfilling-bouncing-circle-spinner
                :animation-duration="2000"
                :size="90"
                color="#2a3042"
              />
            </div>
          </div>
        </div>
      </form>
    </b-modal>
    <!-- <PageHeader :title="title" :items="items" /> -->
    <!-- ESTA PARTE ES PARA LA CABECERA -->
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="pt-3">
              <div class="row justify-content-center">
                <div class="col-xl-12">
                  <div class="text-center">
                    <div class="mb-4">
                      <h4>NUEVA VENTA AL CRÉDITO</h4>
                    </div>
                  </div>
                  <div align="center">
                    <router-link
                      target="_blank"
                      :to="{
                        name: 'nuevaVenta',
                      }"
                    >
                      <b-button
                        block
                        size="md"
                        variant="outline-success"
                        type="button"
                        class="btn btn-rounded mb-2 me-2"
                      >
                        <b>NUEVA PESTAÑA DE VENTA</b>&nbsp;&nbsp;
                        <i class="bx bx-window-open"></i>
                      </b-button>
                    </router-link>
                  </div>
                  <hr />
                  <div class="text-center">
                    <div class="row">
                      <!-- Cliente -->
                      <div class="col-sm-3">
                        <div>
                          <div class="row">
                            <div class="col">
                              <p class="text-muted mb-2">
                                {{
                                  switchCliente ? "Cliente" : "Cliente rápido"
                                }}
                              </p>
                            </div>
                            <div class="col">
                              <switches
                                v-model="switchCliente"
                                class="ms-1"
                                @input="swCliente"
                              ></switches>
                            </div>
                          </div>
                          <div v-if="switchCliente">
                            <v-select
                              v-model.trim="$v.formPro.proveedor.$model"
                              :state="!$v.formPro.proveedor.$error"
                              :options="arrayCliente"
                              @search="selectCliente"
                              @input="cambiarTitulo(formPro.proveedor)"
                              placeholder="Buscar cliente..."
                              label="nombre"
                            >
                              <template slot="no-options">
                                <b-button
                                  block
                                  variant="primary"
                                  v-b-modal.modalCliente
                                  >Nuevo cliente</b-button
                                >
                              </template>
                            </v-select>
                            <div
                              :class="{
                                'invalid-feedback': true,
                                'd-block':
                                  $v.formPro.proveedor.$error &&
                                  !$v.formPro.proveedor.required,
                              }"
                            >
                              Debe seleccionar un cliente
                            </div>
                          </div>
                          <div v-else>
                            <input
                              v-model.trim="$v.formPro.proveedor.$model"
                              :state="!$v.formPro.proveedor.$error"
                              :class="{
                                'is-invalid': $v.formPro.proveedor.$error,
                              }"
                              type="text"
                              class="form-control"
                              placeholder="Ingrese nombre del cliente"
                            />
                            <div
                              :class="{
                                'invalid-feedback': true,
                                'd-block':
                                  $v.formPro.proveedor.$error &&
                                  !$v.formPro.proveedor.required,
                              }"
                            >
                              Nombre requerido
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- Sucursal -->
                      <div class="col-sm-3">
                        <div class="mt-4 mt-sm-0">
                          <p class="text-muted mb-2">Sucursal</p>
                          <input
                            disabled
                            id="name"
                            v-model="$v.formPro.tienda.$model"
                            type="text"
                            class="form-control"
                            placeholder="Registre una Tienda"
                            :class="{
                              'is-invalid': $v.formPro.tienda.$error,
                            }"
                          />
                          <div
                            :class="{
                              'invalid-feedback': true,
                              'd-block':
                                $v.formPro.tienda.$error &&
                                !$v.formPro.tienda.required,
                            }"
                          >
                            Debe Registrar una tienda
                          </div>
                        </div>
                      </div>
                      <!-- Observaciones -->
                      <!-- <div class="col-sm-4">
                        <p class="text-muted mb-2">Observaciones</p>
                        <div class="row">
                          <textarea
                            name="textarea"
                            v-model="formPro.observaciones"
                          ></textarea>
                        </div>
                      </div> -->
                      <!-- Fecha venta -->
                      <div class="col-sm-3">
                        <div>
                          <p class="text-muted mb-2">Fecha venta</p>
                          <h3>
                            {{ showDate(new Date()) }}
                          </h3>
                          <!-- <date-picker
                            v-model.trim="$v.formPro.fecha_compra.$model"
                            :state="!$v.formPro.fecha_compra.$error"
                            :first-day-of-week="1"
                            disabled
                            lang="en"
                          ></date-picker> -->
                        </div>
                      </div>
                      <!-- Total -->
                      <div class="col-sm-3">
                        <div class="mt-4 mt-sm-0">
                          <p class="text-muted mb-2">Total</p>
                          <h3>
                            {{
                              formatQuetzales(
                                formPro.total > 0 ? formPro.total : 0.0
                              )
                            }}
                          </h3>
                          <!-- <input
                            disabled
                            id="name"
                            v-model="$v.formPro.total.$model"
                            type="text"
                            class="form-control"
                            placeholder="No hay un total"
                            :class="{
                              'is-invalid': $v.formPro.total.$error,
                            }"
                          /> -->
                        </div>
                      </div>
                    </div>
                    <br />
                    <hr />
                    <div align="left">
                      <b-card
                        header-class="bg-transparent border-secondary"
                        class="border border-secondary"
                      >
                        <h2>Asignar detalles</h2>
                        <div class="row">
                          <div class="col d-grid gap-2">
                            <b-button
                              block
                              size="lg"
                              variant="primary"
                              v-b-modal.modalProductos
                            >
                              AGREGAR PRODUCTOS&nbsp;&nbsp;<i
                                class="bx bx-grid-alt"
                              ></i>
                            </b-button>
                          </div>
                          <div class="col d-grid gap-2">
                            <b-button
                              block
                              size="lg"
                              variant="primary"
                              v-b-modal.modalServicios
                            >
                              AGREGAR SERVICIOS&nbsp;&nbsp;<i
                                class="bx bx-car"
                              ></i>
                            </b-button>
                          </div>
                          <div class="col d-grid gap-2">
                            <b-button
                              block
                              size="lg"
                              variant="primary"
                              v-b-modal.modalCredito
                            >
                              AGREGAR CRÉDITO&nbsp;&nbsp;<i
                                class="bx bx-car"
                              ></i>
                            </b-button>
                          </div>
                        </div>
                        <br />

                        <h5 v-if="arrayDetalle.length > 0">Productos</h5>
                        <b-table
                          striped
                          v-if="arrayDetalle.length > 0"
                          ref="table"
                          :items="arrayDetalle"
                          :fields="cabezera"
                        >
                          <template #cell(producto)="data">
                            {{ data.item.producto }}<br />
                            {{ data.item.codigo }}
                          </template>
                          <template #cell(opciones)="data">
                            <b-button-group>
                              <b-button
                                v-b-tooltip.focus
                                class="icon-content col-xl-8 col-lg-4 col-sm-"
                                size="md"
                                variant="outline-danger"
                                @click="eliminarDetalle(data)"
                                ><i :class="'bx bx-undo'" />
                              </b-button>
                              <b-button
                                v-b-modal.modalPorcentaje
                                class="icon-content col-xl-8 col-lg-4 col-sm-"
                                size="md"
                                variant="outline-danger"
                                @click="asignarIndex(data.index)"
                                ><strong>%</strong>
                              </b-button>
                            </b-button-group>
                          </template>
                          <template #cell(precio_compra)="data">
                            <b-form-input
                              @keyup="updateDisableDates(data)"
                              v-model="data.item.precio_compra"
                              placeholder="Precio compra"
                            ></b-form-input>
                            <!-- money(data.item.precio_compra) -->
                          </template>
                          <template #cell(porcentaje)="data">
                            <h3>
                              {{ data.item.porcentaje_venta + " %" }}
                            </h3>
                          </template>
                          <template #cell(precio_venta)="data">
                            <div class="input-group mb-3">
                              <b-dropdown
                                :text="data.item.dropdownLabel"
                                variant="primary"
                              >
                                <b-dropdown-item
                                  v-for="(tipo, index) in data.item
                                    .tipos_precio"
                                  @click="cambiarPrecioProducto(tipo, data)"
                                  :key="index"
                                  active
                                  >{{ tipo.nombre }}
                                </b-dropdown-item>
                              </b-dropdown>
                              <b-form-input
                                @keyup="updateDisableDates(data)"
                                v-model="data.item.precio_venta"
                                placeholder="Precio venta"
                              ></b-form-input>
                            </div>
                          </template>
                          <template #cell(subtotal)="data">
                            {{
                              formatQuetzales(
                                data.item.subtotal > 0
                                  ? data.item.subtotal
                                  : 0.0
                              )
                            }}
                          </template>
                          <template #cell(cantidad)="data">
                            <b-form-input
                              @keyup="updateDisableDates(data)"
                              v-model="data.item.cantidad"
                              @input="validarExistencia(data)"
                              placeholder="Ingrese la cantidad"
                            ></b-form-input>
                          </template>
                        </b-table>

                        <h5 v-if="arrayDetalleServicio.length > 0">
                          Servicios
                        </h5>
                        <b-table
                          striped
                          v-if="arrayDetalleServicio.length > 0"
                          ref="table2"
                          :items="arrayDetalleServicio"
                          :fields="cabezera2"
                        >
                          <template #cell(opciones)="data">
                            <b-button
                              tabindex="0"
                              v-b-tooltip.focus
                              title="Eliminar"
                              class="icon-content col-xl-8 col-lg-4 col-sm-"
                              size="sm"
                              variant="outline-danger"
                              @click="eliminarDetalleServicio(data)"
                              ><i :class="'bx bx-undo'"
                            /></b-button>
                          </template>
                          <template #cell(precio_venta)="data">
                            <b-form-input
                              @keyup="sumarCantidadServicio(data)"
                              v-model="data.item.precio_venta"
                              placeholder="Precio compra"
                            ></b-form-input>
                          </template>
                          <template #cell(subtotal)="data">
                            {{
                              formatQuetzales(
                                data.item.subtotal > 0
                                  ? data.item.subtotal
                                  : 0.0
                              )
                            }}
                          </template>

                          <template #cell(cantidad)="data">
                            <b-form-input
                              @keyup="sumarCantidadServicio(data)"
                              v-model="data.item.cantidad"
                              placeholder="Cantidad"
                            ></b-form-input>
                          </template>
                        </b-table>
                      </b-card>
                    </div>
                    <div class="col-sm-12">
                      <div class="row">
                        <div class="col">
                          <router-link
                            class="d-grid gap-2"
                            :to="{
                              name: 'ventas',
                            }"
                          >
                            <b-button
                              block
                              size="lg"
                              variant="outline-primary"
                              type="button"
                              class="btn btn-rounded mb-2 me-2"
                            >
                              <i class="bx bx-arrow-back"></i>&nbsp;&nbsp;<b
                                >REGRESAR</b
                              >
                            </b-button>
                          </router-link>
                        </div>
                        <div class="col d-grid gap-2">
                          <b-button
                            block
                            size="lg"
                            variant="outline-success"
                            class="btn btn-rounded mb-2 me-2"
                            @click="validaciones('save')"
                          >
                            {{ tomandototal() }}
                            <i class="mdi mdi-truck-fast me-1"></i>
                            &nbsp;&nbsp;<b>GUARDAR</b>
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end card -->
    </div>
    <!-- end col -->
  </Layout>
</template>
